import produce from 'immer'
import { handleActions, createAction } from 'redux-actions'
import { combineReducers } from 'redux'

const saveDefaultRoutes = createAction('preferences/saveDefaultRoutes')
const resetDefaultRoutes = createAction('preferences/resetDefaultRoutes')
const saveDashboardReportsFilters = createAction('preferences/saveDashboardReportsFilters')

export const actions = {
  saveDefaultRoutes,
  resetDefaultRoutes,
  saveDashboardReportsFilters,
}

const defaultRoutes = handleActions({
  [saveDefaultRoutes]: produce((draft, action) => {
    const { routeName, options } = action.payload
    draft[routeName] = options
  }),

  [resetDefaultRoutes]: produce((draft, action) => {
    const { routeName } = action.payload
    delete draft[routeName]
  }),
}, {})

const dashboardReportsFilters = handleActions({
  [saveDashboardReportsFilters]: (state, action) => {
    return action.payload
  },
}, {})

export default combineReducers({
  defaultRoutes,
  dashboardReportsFilters,
})

export const createDefaultRoutesSelector =
  routeName => state => state.preferences.defaultRoutes[routeName]

export const selectDashboardReportsFilters =
  state => state.preferences.dashboardReportsFilters
